/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CalendarEventExclusion } from '../../models/calendar-event-exclusion';

export interface GetEventExclusionById$Params {

/**
 * Id of a calendar event.
 */
  eventId: string;

/**
 * Id of a resource.
 */
  id: string;
}

export function getEventExclusionById(http: HttpClient, rootUrl: string, params: GetEventExclusionById$Params, context?: HttpContext): Observable<StrictHttpResponse<CalendarEventExclusion>> {
  const rb = new RequestBuilder(rootUrl, getEventExclusionById.PATH, 'get');
  if (params) {
    rb.path('eventId', params.eventId, {"style":"simple","explode":false});
    rb.path('id', params.id, {"style":"simple","explode":false});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CalendarEventExclusion>;
    })
  );
}

getEventExclusionById.PATH = '/api/v1/calendarEvents/{eventId}/exclusions/{id}';
